// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-7eccd044]{overflow:hidden}.tableWrapper[data-v-7eccd044]{overflow-x:auto}[dir] .resize-cursor[data-v-7eccd044]{cursor:ew-resize;cursor:col-resize}", ""]);
// Exports
module.exports = exports;
